import { getNews } from '@/apis/requests/news';
import NewsDetail from '@/components/NewsDetail';
import Proptypes from 'prop-types';
import { withAuth } from '@/HOC';
import { routingServerAndClientSide } from '@/utils';
import { SubPageLayout } from '@/layouts';

const NewsDetailPage = ({ newsData }) => {
  return <NewsDetail newsData={newsData} />;
};

NewsDetailPage.getInitialProps = async (context) => {
  const { res } = context;
  try {
    const { id } = context.query;
    //id값 없이 접근하는 경우
    if (!id) {
      return routingServerAndClientSide({ res, path: '/news/list' });
    }
    const { data } = await getNews({ id });
    //데이터 응답이 없는 경우
    if (!data?.data) {
      return routingServerAndClientSide({ res, path: '/notfound' });
    }

    return { newsData: data.data };
  } catch (error) {
    return routingServerAndClientSide({ res, path: '/notfound' });
  }
};

NewsDetailPage.proptypes = {
  newsData: Proptypes.object,
};

NewsDetailPage.getLayout = function getLayout(page) {
  return <SubPageLayout>{page}</SubPageLayout>;
};

export default withAuth(NewsDetailPage);
